import { DirectiveBinding } from 'vue'
import { debounce } from 'lodash-es'

/**
 * @description: 用于<el-select>组件下拉选项滚动加载
 *  注意使用的地方teleported设置为false(是否将下拉列表插入至body元素)
 */
export default {
  mounted(el: any, binding: DirectiveBinding) {
    const scrollWrap = el.querySelector('.el-scrollbar__wrap')

    const handle = debounce(() => {
      const scrollDistance = scrollWrap.scrollHeight - scrollWrap.scrollTop
      // 预留10个像素的位置用于触底
      if (scrollWrap.clientHeight + 10 > scrollDistance) {
        const inputVal = el.querySelector('.el-input__inner').value
        binding.value(inputVal)
      }
    }, 200)

    // 绑定监听滚动事件
    scrollWrap?.addEventListener('scroll', handle)

    // 方法挂载到元素身上便于解绑时使用
    el._hanlde = handle
  },
  unmounted(el: any) {
    const scrollWrap = document.querySelector('.el-scrollbar__wrap')
    scrollWrap?.removeEventListener('scroll', el._hanlde)
    el._hanlde = null
  }
}
